import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	imageAlt: {
		id: 'software-deployments.timeline.no-matches.image-alt',
		defaultMessage: 'No results found',
		description:
			'Alternate text for magnifying glass image indicating that there are no deployments to display.',
	},
	noResults: {
		id: 'software-deployments.timeline.no-matches.no-results',
		defaultMessage: 'No matching issues found',
		description: 'Text indicating that there are no deployments to display in the table',
	},
	explanationActiveFilter: {
		id: 'software-deployments.timeline.no-matches.explanation-active-filter',
		defaultMessage: 'Reset your search criteria by changing your filters',
		description: 'Text explaining why there are no deployments to display in the table',
	},
	explanationNoFilter: {
		id: 'software-deployments.timeline.no-matches.explanation-no-filter',
		defaultMessage: 'Try changing your date range',
		description: 'Text explaining why there are no deployments to display in the table',
	},
	learnMore: {
		id: 'software-deployments.timeline.no-matches.learn-more',
		defaultMessage: 'Learn more',
		description: 'A link to a url explaining about how deployments view works',
	},
	clearFilter: {
		id: 'software-deployments.timeline.no-matches.clear-filter',
		defaultMessage: 'Clear filter',
		description: 'Clear filter button caption',
	},
});
